import styled from 'styled-components';
import { Container as Cont, Segment } from 'semantic-ui-react';
import { Link } from "react-router-dom";
import { Table, Button, Select } from "semantic-ui-react";

export const SemanticContainer = styled(Cont)`
  margin: 1em 0 0;
`;

export const SemanticSegment = styled(Segment)`
  text-align: center;
  position: relative;
  bottom: 0;
`;

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #ffffff;
`;

export const Content = styled.div`
  max-width: 80vw;

  margin: auto;
`;

export const Title = styled.h1`
  width: 100%;
  margin: 15px 0px 15px 0px;
  padding: 0px;

  color: #000020;

  font-size: 24px;
  font-family: sans-serif;
  font-weight: 600;

  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;

  & i {
    height: 75% !important;
  }
  input {
    width: 80%;
  }
  button {
    text-align: center;
    width: 40rem;
    margin-left: 4px !important;
  }
`;

export const Input = styled.input`
  height: 35px;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
`;

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: rgba(0, 0, 0, 0.6);
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;
export const StyledLabel = styled.label`
  width: 100px;
  height: 35px;

  margin: 0 1px;

  color: rgba(0, 0, 0, 0.6);
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 1rem;
`;
export const SemanticSelect = styled(Select)`
  height: 35px;
  margin-left: 6px;
`;

export const SemanticTable = styled(Table)`
  border-collapse: collapse;
  margin-top: 2em;
  font-size: 1em;

  th {
    padding: 1em;
  }

  tbody {
    tr {
      /* font-size: 14; */
      /* font-family: sans-serif; */
      /* text-align: left; */
      :hover {
        background: rgba(34, 36, 38, 0.1);
      }

      td {
        padding: 15px;
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      td:first-child {
        max-width: 120px;
      }
    }
  }

  tfoot {
    a {
      color: #000000 !important;

      i {
        color: #000000 !important;
      }
    }
  }
`;

export const LinkRedirect = styled(Link)`
  color: #2185d0 !important;
  cursor: default;

  &:hover {
    text-decoration: none;
    color: #2d8cd4 !important;
  }
`;

export const SemanticButton = styled(Button)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: rgba(0, 0, 0, 0.6);
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif !important;
  font-size: 16px !important;
  font-weight: 600 !important;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;

export const ContainerPaginate = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonIcon = styled.button`
  padding: 0.3rem;
  border: none;
  cursor: pointer;
  margin-left: 1px;
  background: none;

  i {
    &:hover,
    :focus {
      animation: pulse 1s;
      box-shadow: 0 0 0 2em rgba(#fff, 0);
    }
  }
`;
// export const StyeledIconEdit = styled(Icon)`

// `;
